













































































































































import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FindVendaUseCase } from '@/usecases'
import printJS from 'print-js'
import { Component, Vue } from 'vue-property-decorator'

interface Venda {
	identificador: string
	nomeLoja: string
	numeroNota: string
	serieNota: string
	tipoDeTransacao: string
	chaveNfceGerada: string
	vendaId: string
}

@Component({
	components: {},
})
export default class DialogoDeBuscarCuponsDeVendas extends Vue {
	mostra = false
	identificadorVenda = ''
	vendas: Venda[] = []
	carregando = false
	erroMensagem = ''
	carregarImpressao = false
	tipoDeFiltroSelecionado = 'identificadorExterno'
	lojaId = ''

	findVendaUseCase = new FindVendaUseCase()

	headers = [
		{ text: 'Identificador', value: 'identificador', sortable: false },
		{ text: 'Loja', value: 'nomeLoja', sortable: false },
		{ text: 'Nº Nota', value: 'numeroNota', sortable: false },
		{ text: 'Série', value: 'serieNota', sortable: false },
		{ text: 'Tipo de Transação', value: 'tipoDeTransacao', sortable: false },
		{ text: 'Ações', value: 'acoes', sortable: false, align: 'center', width: '80' },
	]

	mostrar(lojaId) {
		this.mostra = true
		this.lojaId = lojaId
		this.identificadorVenda = ''
		this.erroMensagem = ''
	}

	esconder() {
		this.mostra = false
	}

	limpar(){
		localStorage.removeItem('FILTRO_DE_VENDA_MULTIPLO_CUPOM');
		this.vendas = []
	}

	async buscarVenda() {
		if (!this.identificadorVenda) {
			this.erroMensagem = 'Digite um identificador válido'
			return
		}

		if (this.vendas.some(v => v.identificador === this.identificadorVenda)) {
			this.erroMensagem = 'Esta venda já foi adicionada'
			return
		}

		this.carregando = true
		this.erroMensagem = ''

		try {
			
			const params = {
				[this.tipoDeFiltroSelecionado]: this.identificadorVenda,
				lojaId: this.lojaId,
			}

			const nova = await this.findVendaUseCase.find(params)

			if (!nova.content || nova.content.length === 0) {
				this.erroMensagem = 'Venda não encontrada'
				return
			}

			const vendasAdicionadas: Venda[] = []

			for (const item of nova.content) {
				// Valida NFC-e presente
				if (item.notas.filter(n => n.modelo === 'NFC-e').length < 1) {
					this.erroMensagem = 'Não foram encontradas informações sobre o cupom'
					continue
				}

				// Valida status 100
				if (item.notas.filter(n => n.cstat === '100').length < 1) {
					this.erroMensagem = 'A venda deve conter status 100 na NFC-e para impressão do cupom'
					continue
				}

				// Valida se possui NFC-e
				const temNfce = item.notas.some(n => n.modelo === 'NFC-e')
				if (!temNfce) {
					this.erroMensagem = 'Necessário ser uma venda com NFC-e para impressão do cupom'
					continue
				}

				// Valida nota não eletrônica
				if (item.possuiNotaNaoEletronica) {
					this.erroMensagem = 'Necessário ser uma venda com NFC-e para impressão do cupom'
					continue
				}

				// Evita duplicatas que já estejam na lista atual
				const jaExiste = this.vendas.some(v => v.vendaId === item.id)
				if (jaExiste) continue

				vendasAdicionadas.push({
					identificador: this.identificadorVenda,
					nomeLoja: item.pontoDeVenda?.loja?.nome ?? '',
					numeroNota: item.notas?.[0]?.nnf ?? '',
					serieNota: item.notas?.[0]?.serie ?? '',
					tipoDeTransacao: item.tipoDeTransacao ?? '',
					chaveNfceGerada: item.notas?.[0]?.chNFe ?? '',
					vendaId: item.id,
				})
			}

			if (vendasAdicionadas.length === 0) {
				// erroMensagem já foi setado nas validações acima, ou seta genérico
				if (!this.erroMensagem) {
					this.erroMensagem = 'Nenhuma venda válida encontrada'
				}
				return
			}

			this.vendas.push(...vendasAdicionadas)
			localStorage.setItem('FILTRO_DE_VENDA_MULTIPLO_CUPOM', JSON.stringify(this.vendas))
			this.identificadorVenda = ''
			this.erroMensagem = ''

		} catch (error) {
			this.erroMensagem = 'Venda não encontrada'
		} finally {
			this.carregando = false
		}
	}

	removerVenda(identificador: string) {
		this.vendas = this.vendas.filter(v => v.identificador !== identificador)
	}

	async imprimir() {
		this.carregarImpressao = true

		try {
			const response = await this.findVendaUseCase.imprimirMultiplosCupons(
				this.vendas.map(venda => venda.vendaId),
			);

			imprimePdf(response, this.vendas[0].vendaId)
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.carregarImpressao = false
			this.limpar()			
		}
	}

	created() {
		const vendasSalvas = localStorage.getItem('FILTRO_DE_VENDA_MULTIPLO_CUPOM');
		this.vendas = vendasSalvas ? JSON.parse(vendasSalvas) : [];
	}
}

function imprimePdf(response: any, nomeDoArquivo: string) {
	const blob = new Blob([response], { type: 'application/pdf' })
	const url = window.URL.createObjectURL(blob)

	return Promise.race([
		new Promise<void>((resolve, reject) => {
			printJS({
				printable: url,
				type: 'pdf',
				documentTitle: `${nomeDoArquivo}.pdf`,
				onError: error => reject(error),
				onLoadingEnd: () => {
					resolve()
					window.URL.revokeObjectURL(url)
				},
			})
		}),
		new Promise((_, reject) =>
			setTimeout(
				() => reject('Erro ao gerar impressão, verifique as configurações'),
				15000,
			),
		),
	])
}
